import React from 'react'
import '../style.scss'
import { Container } from 'react-bootstrap'
import * as ReactIcons from '@src/lib/react-icons'
import { ReportService } from '@src/domain/services'
import { ItemListDto } from '@src/store/report.slice'

interface CarStatisticsDashProps {
  itemListData: ItemListDto;
}

export const CarStatisticsDash: React.FC<CarStatisticsDashProps> = ({ itemListData }) => {
  const { data } = itemListData as ReportService.GetCarStatisticsRespBo
  const { moving, assembly, quality, repair } = data
  return (
    <Container>
      <div className='dashboard'>
        <div className='card-wrap'>
          <div className='card-icon card-icon-complete'>
            <ReactIcons.PiArrowsLeftRightBold />
          </div>
          <div>
            <h4><strong>移車</strong></h4>
            <div style={{ margin: '5px' }}>
              <p>{`總進廠台數：${moving?.movingInCount}`}</p>
              <p>{`總出廠台數：${moving?.movingOutCount}`}</p>
              <p>{`平均移車時間：${moving?.movingAvgTimeRange}`}</p>
              <p>{`最長移車時間：${moving?.movingMaxTimeRange}`}</p>
              <p>{`最短移車時間：${moving?.movingMinTimeRange}`}</p>
            </div>
          </div>
        </div>
        <div className='card-wrap'>
          <div className='card-icon card-icon-checked'>
            <ReactIcons.TiSpanner />
          </div>
          <div>
            <h4><strong>組裝</strong></h4>
            <div style={{ margin: '5px' }}>
            <p>{`總組裝台數：${assembly?.assemblyCount}`}</p>
            <p>{`平均組裝時間：${assembly?.assemblyAvgTimeRange}`}</p>
            <p>{`最長組裝時間：${assembly?.assemblyMaxTimeRange}`}</p>
            <p>{`最短組裝時間：${assembly?.assemblyMinTimeRange}`}</p>
            </div>
          </div>
        </div>
        <div className='card-wrap'>
          <div className='card-icon card-icon-assembling'>
            <ReactIcons.FaClipboardCheck />
          </div>
          <div>
            <h4><strong>品檢</strong></h4>
            <div style={{ margin: '5px' }}>
            <p>{`總品檢台數：${quality?.qualityCount}`}</p>
            <p>{`平均品檢時間：${quality?.qualityAvgTimeRange}`}</p>
            <p>{`最長品檢時間：${quality?.qualityMaxTimeRange}`}</p>
            <p>{`最短品檢時間：${quality?.qualityMinTimeRange}`}</p>
            </div>
          </div>
        </div>
        <div className='card-wrap'>
          <div className='card-icon card-icon-checking'>
            <ReactIcons.GrPowerCycle />
          </div>
          <div>
            <h4><strong>修復</strong></h4>
            <div style={{ margin: '5px' }}>
            <p>{`總修復台數：${repair?.repairCount}`}</p>
            <p>{`平均修復時間：${repair?.repairAvgTimeRange}`}</p>
            <p>{`最長修復時間：${repair?.repairMaxTimeRange}`}</p>
            <p>{`最短修復時間：${repair?.repairMinTimeRange}`}</p>
            </div>
          </div>
        </div>
      </div>
    </Container>
  )
}
